import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import "./index.css";

import App from "./App";
import { initializeTheme } from "lib/theme";

initializeTheme();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <App />
    <Toaster
      position="top-center"
      toastOptions={{
        duration: 3500,
        style: {
          fontFamily: "'Tajawal', sans-serif",
          direction:
            document?.documentElement?.getAttribute("dir") === "rtl" ||
            document?.documentElement?.getAttribute("lang") === "ar"
              ? ("rtl" as const)
              : ("ltr" as const),
        },
      }}
    />
  </BrowserRouter>
);
